import { render, staticRenderFns } from "./TaxRateModal.vue?vue&type=template&id=01abd527&scoped=true"
import script from "./TaxRateModal.vue?vue&type=script&lang=js"
export * from "./TaxRateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01abd527",
  null
  
)

export default component.exports